export enum DocumentType {
  FILLED_FORM = "filled_form",
  APPROVAL_LETTER = "approval_letter",
  DENIAL_LETTER = "denial_letter",
  NAR_LETTER = "nar_letter",
}
